/**
 * EFKM.com — Main JS Entry Point
 * ================================
 * Imports CSS (processed by PostCSS via Rollup) and all JS modules.
 */

// CSS — processed by rollup-plugin-postcss
import '../css/index.css';

// JS modules
import menuOpen from './menuOpen';
import darkMode from './darkMode';
import gardenFilter from './gardenFilter';
import infiniteScroll from './infiniteScroll';
import nowTimeline from './nowTimeline';

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    menuOpen();
    darkMode();
    gardenFilter();
    infiniteScroll();
    nowTimeline();
});
